export const actionTypes = {
  USER_ROLE: 'AUTHENTICATION/USER_ROLE',
  RESET_USER_ROLE: 'AUTHENTICATION/RESET_USER_ROLE',
};
